import { CellWithTooltip } from "@/components/data-table/CellWithTooltip";
import { ColumnHeader } from "@/components/data-table/ColumnHeader";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { format } from "date-fns";
import { AppTable } from "../../types/app.type";
import GetAppDeploymentStatus from "../QuickCreateApp/DeployingAppStatus/GetAppDeploymentStatus";
import { GetDeployingStatus } from "../QuickCreateApp/DeployingAppStatus/GetDeployingStatus";
import AppActionsCell from "./AppActionsCell";

const columnHelper = createColumnHelper<AppTable>();

export const columns: ColumnDef<AppTable>[] = [
  {
    accessorKey: "appImage",
    cell: ({ row }) => {
      return (
        <div className="h-full w-fit">
          <img
            className="object-cover h-12 rounded"
            src={row.getValue("appImage") || "/app-placeholder-picture.png"}
            alt=""
          />
        </div>
      );
    },
    header: undefined,
    enableHiding: false
  },
  {
    accessorKey: "displayName",
    header: ({ column }) => <ColumnHeader column={column} title="App" />,
    cell: ({ row }) => {
      const {
        isNewAppDisabled,
        isDeployingNewApp,
        isDoneDeployingNewApp,
        isErrorDeployingNewApp
      } = GetDeployingStatus(row.original.id);
      return (
        <span className="flex flex-col-reverse">
          <GetAppDeploymentStatus
            isNewAppDisabled={isNewAppDisabled}
            isDeployingNewApp={isDeployingNewApp}
            isDoneDeployingNewApp={isDoneDeployingNewApp}
            isErrorDeployingNewApp={isErrorDeployingNewApp}
          />
          <CellWithTooltip
            data-testid="appName"
            cellValue={row.getValue("displayName")}
          />
        </span>
      );
    }
  },
  {
    accessorKey: "created",
    header: ({ column }) => <ColumnHeader column={column} title="Created At" />,
    cell: ({ row }) => {
      return format(row.getValue("created"), "PP");
    }
  },
  {
    accessorKey: "updatedAt",
    header: ({ column }) => <ColumnHeader column={column} title="Updated At" />,
    cell: ({ row }) =>
      row.original.updatedAt ? format(row.getValue("updatedAt"), "PP") : null
  },
  {
    accessorKey: "origin",
    header: ({ column }) => <ColumnHeader column={column} title="Origin" />,
    cell: ({ row }) =>
      row.original.origin !== "organization" ? (
        <div className="capitalize">{row.original.origin}</div>
      ) : null
  },
  columnHelper.display({
    id: "actions",
    cell: ({ row }) => <AppActionsCell app={row.original} />
  })
];
